module.exports = __webpack_public_path__ + "img/Intelligence.21bb1079.png";